module.exports = __webpack_public_path__ + "img/map.d392e226.png";